import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import {
  DATA_SITE_PRODUCTION_STORE_FIELD,
  DATA_SITE_HEALTH_STORE_FIELD,
  DATA_SITE_FEED_STORE_FIELD,
  DATA_SITE_ENVIRONMENT_STORE_FIELD,
  DATA_LOCUS_PRODUCTION_STORE_FIELD,
  DATA_LOCUS_HEALTH_STORE_FIELD,
  DATA_LOCUS_FEED_STORE_FIELD,
  DATA_LOCUS_ENVIRONMENT_STORE_FIELD,
} from 'constants/view'

// constants
export const FETCH_SITE_LIST = 'view/FETCH_SITE_LIST'
export const SET_SITE_LIST = 'view/SET_SITE_LIST'
export const FETCH_LOCUS_LIST = 'view/FETCH_LOCUS_LIST'
export const SET_LOCUS_LIST = 'view/SET_LOCUS_LIST'
export const FETCH_SITE_DATA = 'view/FETCH_SITE_DATA'
export const FETCH_LOCUS_DATA = 'view/FETCH_LOCUS_DATA'
export const SET_DATA = 'view/SET_DATA'
export const SET_ACTIVE_SITE = 'view/SET_ACTIVE_SITE'
export const SET_ACTIVE_LOCUS = 'view/SET_ACTIVE_LOCUS'
export const SET_ACTIVE_PERIOD = 'view/SET_ACTIVE_PERIOD'
export const SET_ACTIVE_TAB = 'view/SET_ACTIVE_TAB'
export const RESET_VIEW_STORE = 'view/RESET_STORE'
export const SET_MOBILE_FILTERS = 'view/SET_MOBILE_FILTERS'
export const FETCH_POPULATION_DATA = 'view/FETCH_POPULATION_DATA'
export const SET_POPULATION_DATA = 'view/SET_POPULATION_DATA'
export const UNSET_MOBILE_FILTERS = 'view/UNSET_MOBILE_FILTERS'
export const SET_SIDE_INFO_PANEL = 'view/SET_SIDE_INFO_PANEL'
export const UNSET_SIDE_INFO_PANEL = 'view/UNSET_SIDE_INFO_PANEL'

// actions
export const fetchSiteList = ActionHelper.createActionObj(FETCH_SITE_LIST)
export const fetchLocusList = ActionHelper.createActionObj(FETCH_LOCUS_LIST)
export const setLocusList = ActionHelper.createActionObj(SET_LOCUS_LIST)
export const fetchSiteData = ActionHelper.createActionObj(FETCH_SITE_DATA)
export const fetchLocusData = ActionHelper.createActionObj(FETCH_LOCUS_DATA)
export const fetchPopulationData = ActionHelper.createActionObj(
  FETCH_POPULATION_DATA,
)
export const setPopulationData = ActionHelper.createActionObj(
  SET_POPULATION_DATA,
)
export const setActiveSite = ActionHelper.createActionObj(SET_ACTIVE_SITE)
export const setActiveLocus = ActionHelper.createActionObj(SET_ACTIVE_LOCUS)
export const setActivePeriod = ActionHelper.createActionObj(SET_ACTIVE_PERIOD)
export const setActiveTab = ActionHelper.createActionObj(SET_ACTIVE_TAB)
export const setData = ActionHelper.createActionObj(SET_DATA)
export const resetViewStore = ActionHelper.createActionObj(RESET_VIEW_STORE)
export const setMobileFilters = ActionHelper.createActionObj(SET_MOBILE_FILTERS)
export const unsetMobileFilters = ActionHelper.createActionObj(
  UNSET_MOBILE_FILTERS,
)
export const setSideInfoPanel = ActionHelper.createActionObj(
  SET_SIDE_INFO_PANEL,
)
export const unsetSideInfoPanel = ActionHelper.createActionObj(
  UNSET_SIDE_INFO_PANEL,
)

const initialState = fromJS({
  siteList: [],
  locusList: [],
  activeSite: null,
  activeLocus: null,
  activePeriod: { id: 'today', name: 'Today' }, // today | past | future
  activeTab: 'production', // production | health | feed | environment
  mobileFilters: true,
  populationData: {},
  infoPanel: false,
  [DATA_SITE_PRODUCTION_STORE_FIELD]: {},
  [DATA_SITE_HEALTH_STORE_FIELD]: {},
  [DATA_SITE_FEED_STORE_FIELD]: {},
  [DATA_SITE_ENVIRONMENT_STORE_FIELD]: {},
  [DATA_LOCUS_PRODUCTION_STORE_FIELD]: {},
  [DATA_LOCUS_HEALTH_STORE_FIELD]: {},
  [DATA_LOCUS_FEED_STORE_FIELD]: {},
  [DATA_LOCUS_ENVIRONMENT_STORE_FIELD]: {},
})

const view = handleActions(
  {
    [SET_SIDE_INFO_PANEL]: state => state.set('infoPanel', true),
    [UNSET_SIDE_INFO_PANEL]: state => state.set('infoPanel', false),
    [SET_MOBILE_FILTERS]: state => state.set('mobileFilters', true),
    [UNSET_MOBILE_FILTERS]: state => state.set('mobileFilters', false),
    [SET_SITE_LIST]: (state, action) =>
      state.set('siteList', List(action.siteList)),
    [SET_LOCUS_LIST]: (state, action) =>
      state.set('locusList', List(action.locusList)),
    [SET_ACTIVE_SITE]: (state, action) =>
      state.set('activeSite', action.payload ? Map(action.payload) : null),
    [SET_ACTIVE_LOCUS]: (state, action) =>
      state.set('activeLocus', action.payload ? Map(action.payload) : null),
    [SET_ACTIVE_PERIOD]: (state, action) =>
      state.set('activePeriod', action.payload ? Map(action.payload) : null),
    [SET_ACTIVE_TAB]: (state, action) => state.set('activeTab', action.payload),
    [SET_DATA]: (state, action) =>
      state.set(action.payload.store, Map(action.payload.data)),
    [SET_POPULATION_DATA]: (state, action) =>
      state.set('populationData', Map(action.payload)),
    [RESET_VIEW_STORE]: state =>
      state.set('siteList', List([])).set('locusList', List([])),
  },
  initialState,
)

export default view
